export default __webpack_public_path__ + "static/nus-f1b10be5ee3d14599f885f0cd1a45597.png";